import { css, cva } from "../../../../../styled-system/css";

export const styles = {
  card: cva({
    base: {
      position: "sticky",
      marginLeft: "auto",
      marginRight: "auto",
      borderRadius: "baseUnit.mobile4",
      padding: "baseUnit.mobile4",
      boxShadow: "elevatedCard",
    },
    variants: {
      index: {
        0: { width: "296px", desktop: { width: "592px" } },
        1: { width: "312px", desktop: { width: "608px" } },
        2: { width: "328px", desktop: { width: "624px" } },
        3: { width: "344px", desktop: { width: "640px" } },
      },
    },
  }),

  badge: () =>
    css({
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "white",
      borderRadius: "200px",
      paddingX: "baseUnit.mobile2",
      paddingY: "baseUnit.mobile1",
      boxShadow: "elevatedCard",
      fontWeight: 800,
      fontSize: "body.shrimp",
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      whiteSpace: "nowrap",
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),

  bodyText: (hasBadge: boolean) =>
    css({
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      marginTop: hasBadge ? "baseUnit.mobile2" : undefined,
      marginBottom: 0,
      desktop: {
        fontSize: "body.horse",
        lineHeight: "body.horse",
        letterSpacing: "body.horse",
      },
    }),
};
